module.exports = __webpack_public_path__ + "static/media/fultab41.a84d4d18.jpg";